// Funções pequenas e reutilizadas em várias telas do onboarding/app.

/**
 * Resolve um campo de imagem que pode ser:
 *   - null                              -> sem imagem ainda
 *   - 'https://...'                     -> link direto
 *   - { male: null|url, female: null|url } -> escolhe pelo gênero respondido
 */
export function resolveImage(field, gender) {
  if (field == null) return null;
  if (typeof field === 'string') return field;
  if (typeof field === 'object') {
    return field[gender] ?? field.female ?? field.male ?? null;
  }
  return null;
}

export function formatDatePlusDays(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long' });
}

export function cmToFtIn(cm) {
  const totalInches = Math.round(cm / 2.54);
  const ft = Math.floor(totalInches / 12);
  const inch = totalInches % 12;
  // Bug corrigido (01/10/2026): arredondar a polegada ANTES de separar pés
  // podia estourar pra "12\"" (ex: 182cm virava 5'12" em vez de 6'0").
  // Arredondando o total de polegadas primeiro e só depois dividindo por
  // 12, o carry fica sempre certo.
  return `${ft}'${inch}"`;
}

export function kgToLb(kg) {
  return Math.round(kg * 2.20462);
}

export function fillTemplate(template, vars = {}) {
  return template.replace(/\{(\w+)\}/g, (_, key) => (vars[key] ?? `{${key}}`));
}
